import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Clock, BookOpen, LifeBuoy } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-parchment py-20 px-6 md:px-8" data-id="element-113">
      <div className="max-w-2xl mx-auto" data-id="element-114">
        <AnimatedSection data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-serif text-bark mb-4 text-center" data-id="element-116">
            Lo que cambia todo: no más fuerza de voluntad.
          </h2>
          <p className="text-xl font-serif italic text-bark/70 text-center mb-12" data-id="element-117">
            Un sistema pequeño.
          </p>

          <div className="space-y-6 text-lg text-bark/90 leading-relaxed mb-12" data-id="element-118">
            <p data-id="element-119">Este ebook no es “motivación”.</p>
            <p data-id="element-120">
              Es un <span className="font-bold text-wine" data-id="element-121">método</span>.
            </p>
            <p data-id="element-122">
              Se llama{' '}
              <span className="font-bold" data-id="element-123">Micro‑regla de fidelidad</span>:
            </p>
          </div>

          <div className="space-y-6 mb-12" data-id="element-124">
            <div className="flex items-start gap-4 p-4 bg-linen rounded-sm shadow-sm border border-tan/20" data-id="element-125">
              <div className="bg-gold/10 p-2 rounded-full text-gold mt-1" data-id="element-126">
                <Clock size={24} data-id="element-127" />
              </div>
              <div data-id="element-128">
                <h3 className="font-serif font-bold text-xl text-bark" data-id="element-129">
                  7 minutos por día.
                </h3>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-linen rounded-sm shadow-sm border border-tan/20" data-id="element-130">
              <div className="bg-gold/10 p-2 rounded-full text-gold mt-1" data-id="element-131">
                <BookOpen size={24} data-id="element-132" />
              </div>
              <div data-id="element-133">
                <h3 className="font-serif font-bold text-xl text-bark" data-id="element-134">
                  Guiones listos
                </h3>
                <p className="text-bark/80 text-base" data-id="element-135">
                  (mañana, noche y emergencia).
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-linen rounded-sm shadow-sm border border-tan/20" data-id="element-136">
              <div className="bg-gold/10 p-2 rounded-full text-gold mt-1" data-id="element-137">
                <LifeBuoy size={24} data-id="element-138" />
              </div>
              <div data-id="element-139">
                <h3 className="font-serif font-bold text-xl text-bark" data-id="element-140">
                  Plan de Rescate 24h
                </h3>
                <p className="text-bark/80 text-base" data-id="element-141">
                  para volver sin reiniciar y sin culpa.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center p-8 border-t border-b border-gold/20" data-id="element-142">
            <p className="text-xl md:text-2xl font-serif italic text-bark" data-id="element-143">
              “Tu problema no es que no reces. Tu problema es que cuando fallás,{' '}
              <span className="font-bold text-wine not-italic" data-id="element-144">te vas</span>.
              Acá aprendés a volver.”
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}